import { render, staticRenderFns } from "./SupportRequestPrompt.vue?vue&type=template&id=34c7e277"
import script from "./SupportRequestPrompt.vue?vue&type=script&lang=js"
export * from "./SupportRequestPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports